import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/team/hamza.jpeg")